import { render } from "./home-comment.vue?vue&type=template&id=3acc5e41&scoped=true"
import script from "./home-comment.vue?vue&type=script&lang=js"
export * from "./home-comment.vue?vue&type=script&lang=js"

import "./home-comment.vue?vue&type=style&index=0&id=3acc5e41&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3acc5e41"],['__file',"src/components/home/home-comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3acc5e41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3acc5e41', __exports__)) {
    api.reload('3acc5e41', __exports__)
  }
  
  module.hot.accept("./home-comment.vue?vue&type=template&id=3acc5e41&scoped=true", () => {
    api.rerender('3acc5e41', render)
  })

}


export default __exports__